// Sentinel placeholders resolved to live values at send time.
export const FACILITY_EMAIL_TOKEN = "{{facility_email}}";
export const DM_EMAIL_TOKEN = "{{dm_email}}";

export type ExternalReceiptToken = typeof FACILITY_EMAIL_TOKEN | typeof DM_EMAIL_TOKEN;

export interface ExternalReceiptSelection {
  facility: boolean;
  dm: boolean;
  custom: string[];
}

// Reads checkbox state and custom addresses from the stored array.
export function splitExternalReceipts(entries: string[]): ExternalReceiptSelection {
  return {
    facility: entries.includes(FACILITY_EMAIL_TOKEN),
    dm: entries.includes(DM_EMAIL_TOKEN),
    custom: entries.filter((e) => e !== FACILITY_EMAIL_TOKEN && e !== DM_EMAIL_TOKEN)
  };
}

// Rebuilds the stored array from checkbox and custom-address state.
export function joinExternalReceipts(selection: ExternalReceiptSelection): string[] {
  const tokens: string[] = [];
  if (selection.facility) tokens.push(FACILITY_EMAIL_TOKEN);
  if (selection.dm) tokens.push(DM_EMAIL_TOKEN);
  return [...tokens, ...selection.custom];
}
